import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Tabs,
  Checkbox,
  Select,
  Button,
  Input,
  Tooltip,
  Collapse,
  List,
} from "antd";
import BackArrow from "../../../../../assets/BackArrow.svg";
import BackArrowWhite from "../../../../../assets/WhiteIcons/BackArrow_White.svg";
import WidgetCard from "../WidgetCard";
import General from "./General";
import Filters from "./Filters";
import { useDispatch, useSelector } from "react-redux";
import {
  setBubbleRef,
  setFilterActiveKey,
  setFilterApplied,
  setFilterChange,
  setIsWidgetEdit,
  setRemoveWordsPanelFlag,
  setWidgetClearFilter,
} from "../../../../../redux/actions/Filter";

import {
  setFilterObject,
  setTemplateFilter,
  setTemplateFiltersObj,
} from "../../../../../redux/actions/section/section";
import {
  getAllFilters,
  getBrands,
  getCustomizedDate,
  getDefaultCompBrand,
  getExcludedWords,
  getGlobalBrands,
  getPaneIndex,
  getTemporaryWordWidgetId,
  getWidgetGraphObject,
  getWindowLocationPath,
} from "../../../../../redux/constants";
import { setTemporaryWords } from "../../../../../redux/actions/Attribute";
import moment from "moment";
import {
  getProfileFilterList,
  setAggregateData,
  setGraphData,
} from "../../../../../redux/actions/ApiCall";
import {
  setPageChart,
  setWidgetMakerGraphData,
} from "../../../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setDashboardWidgetProfileFilters,
  setWidgetData,
} from "../../../../../redux/actions/dashboard/Tab1";
import {
  getBrandHiddenWords,
  setWordcloudModifyWords,
} from "../../../../../redux/actions/ApiCall/apiCall";
import search from "../../../../../assets/search_icon.svg";
import searchWhite_icon from "../../../../../assets/WhiteIcons/searchWhite_icon.svg";
import { setEditPanel } from "../../../../../redux/actions/dashboard/dashboard";
import {
  setClearBrandAndDuration,
  setCompetitorBrandType,
  setDashboardBrandObj,
} from "../../../../../redux/actions/Template";
import { setDashboardDateFilterObj } from "../../../../../redux/actions/DateTime";
import {
  setDateAggregationLoader,
  setStreamScreenBrand,
  setStreamScreenFilters,
  updateScreenWidgetPropdataWithClearGraphData,
} from "../../../../../redux/actions/commandCenter/screens/screen";
import { getUniqueValues } from "../../../../../redux/constants/commandCenterConstants";
import { setCommandCenterWordcloudModifyWords } from "../../../../../redux/actions/commandCenter/commandCenterApi";
import { screensWithPersistedFilters } from "../../../../../redux/constants/enums";
import CkEditorPulgin from "../../../shareable/CkEditorPlugin";
import {
  setPdfEditorObject,
  setPdfEditorPanel,
} from "../../../../../redux/actions/scheduleReport/scheduleReport";
const { Panel } = Collapse;

const EditWidget = ({ setColumnSpan }) => {
  const ref = useRef();

  const dispatch = useDispatch();
  const { TabPane } = Tabs;
  const [tabsKey, setTabskey] = useState(false);
  const selectedSection = useSelector((state) => state.Section.filterObject);
  const totalHiddenBrandWords = useSelector(
    (state) => state.ApiCall.brandHiddenWords
  );
  const templateFilterObj = useSelector(
    (state) => state?.Section?.templateFilterObj
  );
  const dashboardBrandObj = useSelector(
    (state) => state?.Template?.dashboardBrandObj
  ); //add in dashboard section and dashboard widget
  const dashboardDateFilterObj = useSelector(
    (state) => state?.DateTime?.dashboardDateFilterObj
  );
  const removeWidgetFlag = useSelector(
    (state) => state.Filter.removeWidgetFlag
  );
  const Section = useSelector((state) => state.Section.addSection);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKeys = useSelector((state) => state?.Tab1?.activeKey);
  const screen = useSelector((state) => state?.Screens?.screen);
  const workspace_privileges = useSelector(
    (state) => state?.ApiCall?.workspace_privileges
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const graphLoader = useSelector((state) => state.apiCall.loader);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const isWidgetEdit = useSelector((state) => state.Filter.isWidgetEdit);
  const [widgetsClearFilter, setwidgetsClearFilter] = useState(false);
  const [checked, setChecked] = useState(false);

  const [isFilterApplied, setisFilterApplied] = useState(false);
  const [temporaryWordArray, setTemporaryWordArray] = useState([]);
  const [permanentWordArray, setPermanentWordArray] = useState([]);
  const [searchtext, setsearchtext] = useState(null);
  const [searchPermanent, setsearchPermanent] = useState(null);
  const [searchPermanentBrand, setsearchPermanentBrand] = useState("");
  const [noteEdited, setNoteEdited] = useState(false);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const pdfEditorPanelSatus = useSelector(
    (state) => state?.scheduleReport?.templateObj?.pdfEditorPanelSatus
  );
  const pdfEditorPanelType = useSelector(
    (state) => state?.scheduleReport?.templateObj?.pdfEditorPanelType
  );
  const pdfEditorObj = useSelector(
    (state) => state?.scheduleReport?.pdfEditorObj
  );
  const paneindex = getPaneIndex(panes, activeKey);
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  let isPersonalisedBannerAdded =
    authParams?.screen_id &&
    (personalizationSettingsObj?.CommandCenterLayout === "B1F0" ||
      personalizationSettingsObj?.CommandCenterLayout === "B1F1");
  let activeGroupOrBrand = [];
  if (authParams?.screen_id) {
    if (authParams?.screen_id === "000-000-558") {
      let currentBrand =
        screen?.widgets?.[screen?.current_screen_brand?.currentWidgetIndex]
          ?.widgetSingleBrandFilter;
      activeGroupOrBrand.push(currentBrand);
    } else if (
      (authParams?.screen_id === "000-000-550" &&
        !screen?.settings?.is_competitor) ||
      authParams?.screen_id === "000-000-556"
    ) {
      let currentBrand = screen?.brands?.columns || screen?.brands;
      activeGroupOrBrand = currentBrand;
    } else if (
      authParams?.screen_id === "000-000-550" &&
      screen?.settings?.is_competitor
    ) {
      let currentBrand =
        screen?.widgets?.[screen?.current_screen_brand?.currentWidgetIndex]
          ?.widgetSingleBrandFilter;
      activeGroupOrBrand.push(currentBrand);
    }
  } else {
    let widgetMetaData =
      panes[paneindex]?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
        removeWidgetFlag?.widget_index
      ];
    let sectionMetaData =
      panes[paneindex]?.sections?.[removeWidgetFlag?.section_index];
    let singleSectionMetaData =
      panes[paneindex]?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index];
    if (
      widgetMetaData?.is_locked &&
      (widgetMetaData?.brand_ids || widgetMetaData?.brand_groups)
    ) {
      activeGroupOrBrand =
        widgetMetaData?.brand_ids || widgetMetaData?.brand_groups;
    } else if (
      sectionMetaData?.is_locked &&
      (sectionMetaData?.brand_ids || sectionMetaData?.brand_groups)
    ) {
      activeGroupOrBrand =
        sectionMetaData?.brand_ids || sectionMetaData?.brand_groups;
    } else if (
      singleSectionMetaData?.is_locked &&
      (singleSectionMetaData?.brand_ids || singleSectionMetaData?.brand_groups)
    ) {
      activeGroupOrBrand =
        singleSectionMetaData?.brand_ids || singleSectionMetaData?.brand_groups;
    } else {
      activeGroupOrBrand =
        panes?.[paneindex]?.brands?.columns || panes?.[paneindex]?.brands;
    }
  }

  // add brand name and brand id key(as required structure)
  if (activeGroupOrBrand?.[0]?.brand_id) {
    const brandIdSet = new Set(activeGroupOrBrand.map((item) => item.brand_id));

    activeGroupOrBrand = brands?.reduce((result, brand) => {
      if (brandIdSet.has(brand?.brand_id)) {
        result.push({
          brand_id: brand?.brand_id,
          brand_name: brand?.brand_name || brand?.brand_friendly_name,
        });
      }
      return result;
    }, []);
  }
  let groupOrBrands = {
    groups: [],
    brands: [],
  };

  const [searchTerms, setSearchTerms] = useState({});
  if (activeGroupOrBrand?.length > 0) {
    activeGroupOrBrand?.forEach((element) => {
      if (element?.group || element?.brand_group_name) {
        groupOrBrands.groups.push(
          element.brand_friendly_name || element?.brand_group_name
        );
      } else {
        if (element?.competitor) {
          element.competitorList.forEach((element) => {
            groupOrBrands.brands.push({
              brand_id: element.brand_id,
              brand_name: element.brand_friendly_name,
            });
          });
          // to insert parent element also incase its competitor dash
          groupOrBrands.brands.push({
            brand_id: element.name,
            brand_name: element.brand_friendly_name,
          });
        } else {
          if (
            (authParams?.screen_id === "000-000-550" &&
              !screen?.settings?.is_competitor) ||
            authParams?.screen_id === "000-000-556"
          ) {
            groupOrBrands.brands.push({
              brand_id: element?.name,
              brand_name: element?.brand_friendly_name,
            });
          } else {
            // for competitor screens ie- 558,550 in case of cc
            // for brands in case of dashboards where we have logical groups and brands options to select
            groupOrBrands.brands.push({
              brand_id: authParams?.screen_id
                ? element?.brand_id
                : element?.name || element?.brand_id,
              brand_name: element?.brand_friendly_name || element?.brand_name,
            });
          }
        }
      }
    });
  }

  // to get the list to show of brand hidden words, logical group or brand/s
  let listOfBrandHiddenWords = getExcludedWords(
    totalHiddenBrandWords,
    groupOrBrands
  );
  const groupedData = useMemo(() => {
    return listOfBrandHiddenWords?.reduce((acc, item) => {
      if (!acc[item.name]) {
        acc[item.name] = [];
      }
      acc[item.name].push({ value: item.value, brand_id: item.brand_id });
      return acc;
    }, {});
  }, [listOfBrandHiddenWords]);

  const handleSearch = (term, group) => {
    setSearchTerms({ ...searchTerms, [group]: term });
  };

  const footerValue = useSelector((state) => state.Section.footerValue);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const selectProfileFilterValue = useSelector(
    (state) => state?.ProfileFilter?.selectProfileFilterValue
  );
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const enteredPlannedValue = useSelector(
    (state) => state?.PlannedValue?.enteredPlannedValue
  );
  const widget_metadata =
    selectedSection?.type === "widgetFilter"
      ? selectedSection?.section_index !== null &&
        selectedSection?.section_index >= 0 &&
        selectedSection?.widget_index >= 0
        ? panes[paneindex]?.sections?.[selectedSection?.section_index]
            ?.widgets?.[selectedSection?.widget_index]
        : !selectedSection?.section_index >= 0 &&
          selectedSection?.widget_index >= 0
        ? panes[paneindex]?.section?.[0]?.widgets?.[
            selectedSection?.widget_index
          ]
        : null
      : selectedSection?.type === "template_widget"
      ? selectedSection?.section_index !== null &&
        selectedSection?.section_index >= 0 &&
        selectedSection?.widget_index >= 0
        ? Section[selectedSection?.section_index]?.data?.[
            selectedSection?.widget_index
          ]
        : !selectedSection?.section_index >= 0 &&
          selectedSection?.widget_index >= 0
        ? Section[0]?.data?.[selectedSection?.widget_index]
        : null
      : null;

  let widget_data =
    getWindowLocationPath()?.toLowerCase() === "dashboard"
      ? removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index >= 0 &&
        removeWidgetFlag?.widget_index >= 0
        ? panes[paneindex]?.sections?.[removeWidgetFlag?.section_index]
            ?.widgets?.[removeWidgetFlag?.widget_index]
        : !removeWidgetFlag?.section_index >= 0 &&
          removeWidgetFlag?.widget_index >= 0
        ? panes[paneindex]?.section?.[0]?.widgets?.[
            removeWidgetFlag?.widget_index
          ]
        : null
      : getWindowLocationPath()?.toLowerCase() === "create-dashboard" ||
        getWindowLocationPath()?.toLowerCase() === "edit-dashboard"
      ? removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index >= 0 &&
        removeWidgetFlag?.widget_index >= 0
        ? Section[removeWidgetFlag?.section_index]?.data?.[
            removeWidgetFlag?.widget_index
          ]
        : !removeWidgetFlag?.section_index >= 0 &&
          removeWidgetFlag?.widget_index >= 0
        ? Section[0]?.data?.[removeWidgetFlag?.widget_index]
        : null
      : null;
  let section_metadata = panes[paneindex]?.sections?.[
    removeWidgetFlag?.section_index
  ]
    ? panes[paneindex]?.sections?.[removeWidgetFlag?.section_index]
    : null;
  let Tempcount = 0;
  let Permanentcount = 0;
  let hiddenBrandWordsCount = 0;

  let widget_type =
    selectedSection?.type === "widgetFilter"
      ? "dashboard_widget"
      : selectedSection?.type === "widgetFilter"
      ? "dashboard_widget"
      : selectedSection?.type;

  const handleBackButton = () => {
    if (
      window.location.pathname === "/dashboard" ||
      window.location.pathname === "/pin-dashboard"
    ) {
      let index = getPaneIndex(panes, activeKey);
      let widget_metadata = panes[index]?.sections
        ? panes[index]?.sections?.[selectedSection?.section_index]?.widgets[
            selectedSection?.widget_index
          ]
        : panes[index]?.section?.[0]?.widgets?.[selectedSection?.widget_index];

      if (widget_metadata && !widget_metadata?.profile_filters) {
        // console.log("inside", widget_metadata, widget_metadata?.is_locked);
        if (
          widget_metadata?.brand_ids ||
          widget_metadata?.brand_groups ||
          widget_metadata?.profile_filters_list
        ) {
          let paneObject = {
            index: index,
            brands:
              brandlogicalgroup?.length > 0 ? brandlogicalgroup : Allbrands,
            panes: panes,
            activeKey: activeKey,
            firstSection: true,
            templateDetails: templateDetails,
            singleBrands: Allbrands,
            global_dashboard_duration: global_dashboard_duration,
            global_dashboard_brands: global_dashboard_single_brands,
            graphConditionConfig: graphConditionConfig,
          };
          let profilePayload = {
            hidden_filter: null,
            quick_filter: null,
            isBrandModified: true,
            brands: widget_metadata?.brand_ids
              ? widget_metadata?.brand_ids
              : widget_metadata?.brand_groups,
          };
          paneObject.metadata = widget_metadata;
          if (paneObject.metadata.is_locked) {
            paneObject.metadata.is_locked = true;
          }
          paneObject.sectionIndex = selectedSection?.section_index;
          paneObject.widget_brand_change = true;
          dispatch(
            getProfileFilterList(authParams, profilePayload, paneObject)
          );
        }

        dispatch(
          setDashboardWidgetProfileFilters(
            panes,
            index,
            selectedSection?.section_index,
            selectedSection?.widget_index,
            widget_metadata?.payload?.profile_filters
          )
        );
      }
    }

    dispatch(setRemoveWordsPanelFlag(false));
    dispatch(setIsWidgetEdit(false));
    dispatch(setFilterChange(false));
    dispatch(
      setFilterObject({
        id: null,
        type: null,
        section_index: null,
        widget_index: null,
      })
    );
    dispatch(setEditPanel(null));
    setwidgetsClearFilter(false);
    dispatch(setTemplateFiltersObj(null));
    setsearchPermanent(null);
    setsearchtext(null);
    setsearchPermanentBrand(null);

    // to close or collapse all accordion list
    dispatch(setFilterActiveKey([]));

    // to reset clearBrandAndDuration state
    dispatch(
      setClearBrandAndDuration({
        sectionLevelBrand: false,
        widgetLevelBrand: false,
        sectionLevelDuration: false,
        widgetLevelDuration: false,
      })
    );
    // to reset dashboardDateFilterObj state
    dispatch(setDashboardDateFilterObj(null));
    // to reset dashboardBrandObj state
    dispatch(setDashboardBrandObj(null));
    // to reset competitorBrandType state
    dispatch(setCompetitorBrandType("initial"));

    if (authParams?.screen_id === "000-000-557") {
      // To Clear stream screen filters and Selected Brand
      dispatch(setStreamScreenBrand(null));
      dispatch(setStreamScreenFilters([]));
    }
    dispatch(setPdfEditorPanel(false, null));
    dispatch(
      setPdfEditorObject({
        paneIndex: null,
        panes: null,
        sectionIndex: null,
        widgetIndex: null,
        widgetId: null,
        editorValue: null,
      })
    );
  };

  const handleDone = (noteEdited) => {
    setisFilterApplied(true);
    if (noteEdited) {
      setNoteEdited(true);
    }
    if (authParams?.screen_id) {
      setTabskey(true);
    }
  };

  useEffect(() => {
    if (isWidgetEdit) {
      dispatch(setBubbleRef(ref?.current?.clientWidth));
      if (removeWidgetFlag?.value) {
        if (authParams?.screen_id) {
          let section_metadata =
            removeWidgetFlag?.section_index !== null &&
            removeWidgetFlag?.section_index !== undefined &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]
              ? screen?.sections?.[removeWidgetFlag?.section_index]
              : removeWidgetFlag?.section_index >= 0 &&
                screen?.sections &&
                screen?.sections?.[removeWidgetFlag?.section_index]
              ? screen?.sections?.[removeWidgetFlag?.section_index]
              : screen?.section && screen?.section?.[0]
              ? screen?.section?.[0]
              : null;

          let section_id = section_metadata?.section_id
            ? section_metadata?.section_id
            : screen?.section_id;

          let widget_metadata =
            removeWidgetFlag?.section_index !== null &&
            removeWidgetFlag?.section_index !== undefined &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
              removeWidgetFlag?.widget_index
            ]
              ? screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
                  removeWidgetFlag?.widget_index
                ]
              : removeWidgetFlag?.section_index >= 0 &&
                screen?.sections &&
                screen?.sections?.[removeWidgetFlag?.section_index]
              ? screen?.sections?.[removeWidgetFlag?.section_index]
              : screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
              ? screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
              : screen?.widgets &&
                screen?.widgets?.[removeWidgetFlag?.widget_index]
              ? screen?.widgets &&
                screen?.widgets?.[removeWidgetFlag?.widget_index]
              : null;

          let widget_id = widget_metadata?.widget_id;

          let template_id = screen?.screen_id;
          //for exploded wordcloud by comptitor brands
          if (widget_metadata?.duplicate_for_brands) {
            widget_id = getTemporaryWordWidgetId(widget_metadata);
          }
          if (temporary_words?.[template_id]?.[section_id]?.[widget_id]) {
            setTemporaryWordArray(
              temporary_words[template_id][section_id][widget_id]?.exclude_words
            );
          }

          if (
            widget_metadata?.comp_exclude_words?.find(
              (el) => el?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]
            )?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]?.length
          ) {
            setPermanentWordArray(
              widget_metadata?.comp_exclude_words?.find(
                (el) => el?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]
              )?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]
            );
          } else if (
            widget_metadata?.exclude_words &&
            !widget_metadata?.com_brand_ids
          ) {
            setPermanentWordArray(widget_metadata?.exclude_words);
          } else {
            setPermanentWordArray([]);
          }
        } else {
          let index = getPaneIndex(panes, activeKey);
          let section_id = panes[index]?.section
            ? panes[index]?.section?.[0]?.section_id
            : panes[index]?.sections?.[removeWidgetFlag?.section_index]
                ?.section_id;
          let widget_id = panes[index]?.section
            ? panes[index]?.section?.[0]?.widgets?.[
                removeWidgetFlag?.widget_index
              ]?.widget_id
            : panes[index]?.sections?.[removeWidgetFlag?.section_index]
                ?.widgets?.[removeWidgetFlag?.widget_index]?.widget_id;

          let template_id = panes[index]?.template_id;
          let widget_metadata = panes[index]?.section
            ? panes[index]?.section[0]?.widgets?.[
                removeWidgetFlag?.widget_index
              ]
            : panes[index]?.sections?.[removeWidgetFlag?.section_index]
                ?.widgets?.[removeWidgetFlag?.widget_index];
          //for exploded wordcloud by comptitor brands
          if (widget_metadata?.duplicate_for_brands) {
            widget_id = getTemporaryWordWidgetId(widget_metadata);
          }
          if (temporary_words?.[template_id]?.[section_id]?.[widget_id]) {
            setTemporaryWordArray(
              temporary_words[template_id][section_id][widget_id]?.exclude_words
            );
          }

          if (
            widget_metadata?.comp_exclude_words?.find(
              (el) => el?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]
            )?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]?.length
          ) {
            setPermanentWordArray(
              widget_metadata?.comp_exclude_words?.find(
                (el) => el?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]
              )?.[widget_metadata?.com_brand_ids?.[0]?.brand_id]
            );
          } else if (
            widget_metadata?.exclude_words &&
            !widget_metadata?.com_brand_ids
          ) {
            setPermanentWordArray(widget_metadata?.exclude_words);
          } else {
            setPermanentWordArray([]);
          }
        }
      }
    }
  }, [isWidgetEdit, temporary_words, panes, screen]);

  const handleClear = () => {
    if (
      (selectedSection?.type === "command_center_widget" &&
        !selectedSection?.is_locked) ||
      (screen?.screen_id === "000-000-557" &&
        selectedSection?.type === "command_center_widget")
    ) {
      let filters = null;
      if (selectedSection?.type === "command_center_widget") {
        filters = screen?.sections
          ? screen?.sections[selectedSection?.section_index]?.widgets?.[
              selectedSection?.widget_index
            ]?.filters
            ? screen?.sections[selectedSection?.section_index]?.widgets?.[
                selectedSection?.widget_index
              ]?.filters
            : []
          : screen?.section
          ? screen?.section?.[0]?.widgets?.[selectedSection?.widget_index]
              ?.filters
            ? screen?.section &&
              screen?.section?.[0]?.widgets?.[selectedSection?.widget_index]
                ?.filters
            : []
          : screen?.widgets &&
            screen?.widgets?.[selectedSection?.widget_index]?.filters
          ? screen?.widgets?.[selectedSection?.widget_index]?.filters
          : [];
      }
      if (!filters?.length) {
        handleBackButton();
        return;
      }
    } else if (
      (selectedSection?.type === "widgetFilter" ||
        selectedSection?.type === "sectionFilter") &&
      !selectedSection?.is_locked
    ) {
      let index = getPaneIndex(panes, activeKeys);
      let filters = null;
      let brandFilter = null;
      let dateFilter = null;
      if (selectedSection?.type === "widgetFilter") {
        filters = panes?.[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.widgets?.[
              selectedSection?.widget_index
            ]?.filters
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets?.[
                selectedSection?.widget_index
              ]?.filters
            : []
          : panes?.[index]?.section &&
            panes[index]?.section?.[0]?.widgets?.[selectedSection?.widget_index]
              ?.filters
          ? panes?.[index]?.section &&
            panes?.[index]?.section?.[0]?.widgets?.[
              selectedSection?.widget_index
            ]?.filters
          : [];
        brandFilter = dashboardBrandObj?.brandFilters
          ? dashboardBrandObj?.brandFilters
          : null;
        dateFilter = dashboardDateFilterObj?.dateFilters
          ? [...dashboardDateFilterObj?.dateFilters]
          : [];
      } else if (selectedSection?.type === "sectionFilter") {
        filters = panes[index]?.sections[selectedSection?.section_index]
          ?.filters
          ? panes[index]?.sections[selectedSection?.section_index]?.filters
          : [];
        brandFilter = dashboardBrandObj?.brandFilters
          ? dashboardBrandObj?.brandFilters
          : null;
        dateFilter = dashboardDateFilterObj?.dateFilters
          ? [...dashboardDateFilterObj?.dateFilters]
          : [];
      }
      if (!filters?.length && !brandFilter?.length && !dateFilter?.length) {
        handleBackButton();
        return;
      }
    } else if (
      (selectedSection?.type === "template_widget" ||
        selectedSection?.type === "template_section") &&
      !selectedSection?.is_locked
    ) {
      let filters = null;
      let brandFilter = null;
      let dateFilter = null;
      if (selectedSection?.type === "template_widget") {
        let widget_metadata =
          selectedSection?.section_index >= 0 &&
          selectedSection?.section_index !== null
            ? Section?.[selectedSection?.section_index]?.data?.[
                selectedSection?.widget_index
              ]
            : Section?.[0]?.data?.[selectedSection?.widget_index];
        filters = widget_metadata?.onlyFilters;
        brandFilter = widget_metadata?.brandFilters;
        dateFilter = widget_metadata?.dateFilters;
      } else if (selectedSection?.type === "template_section") {
        let currectSection = Section?.[selectedSection?.section_index];
        filters = currectSection?.onlyFilters;
        brandFilter = currectSection?.brandFilters;
        dateFilter = currectSection?.dateFilters;
      }
      if (!filters?.length && !brandFilter && !dateFilter) {
        handleBackButton();
        return;
      }
    }
    setwidgetsClearFilter(true);
    handleDone();
  };
  const callback = (key) => {
    // to close or collapse accordion list
    dispatch(setFilterActiveKey([]));
    key === "1" ? setTabskey(false) : setTabskey(true);
    setsearchPermanent(null);
    setsearchtext(null);
    setsearchPermanentBrand(null);
  };

  const handleLock = (e) => {
    setChecked(e?.target?.checked);
    dispatch(setFilterObject(selectedSection, e?.target?.checked));
  };

  useEffect(
    () => setChecked(selectedSection?.is_locked),
    [selectedSection?.is_locked]
  );
  const unhidePermanentlyBrand = (keyword, name = null, id = null) => {
    let group = groupOrBrands?.groups?.includes(name);
    if (
      authParams?.screen_id === "000-000-552" ||
      authParams?.screen_id === "000-000-556"
    ) {
      dispatch(setDateAggregationLoader(true));
    }
    if (authParams?.screen_id) {
      // code for unhide Permanently
      let section_metadata =
        removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : removeWidgetFlag?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : screen?.section && screen?.section?.[0]
          ? screen?.section?.[0]
          : null;

      let section_id = section_metadata?.section_id
        ? section_metadata?.section_id
        : screen?.section_id;
      let widget_metadata =
        removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
          removeWidgetFlag?.widget_index
        ]
          ? screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
              removeWidgetFlag?.widget_index
            ]
          : removeWidgetFlag?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
          ? screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
          : screen?.widgets && screen?.widgets?.[removeWidgetFlag?.widget_index]
          ? screen?.widgets && screen?.widgets?.[removeWidgetFlag?.widget_index]
          : null;

      let screen_id = screen?.screen_id;
      let widget_id = widget_metadata?.parentId
        ? widget_metadata?.parentId
        : widget_metadata?.childId
        ? widget_metadata?.childId
        : widget_metadata?.widget_id;
      let comp_include_words = [];
      if (widget_metadata?.duplicate_for_brands) {
        widget_id = widget_metadata?.parentId
          ? widget_metadata?.parentId
          : widget_metadata?.childId
          ? widget_metadata?.childId
          : widget_metadata?.widget_id;
        let brand_id = widget_metadata?.payload?.brand_list?.[0]?.brand_id;
        comp_include_words.push({
          [brand_id]: keyword?.length > 0 ? [keyword] : [],
        });
      }
      let paneObject = {
        competitorBrands: competitorBrands,
        widget_metadata: widget_metadata,
        section_index: removeWidgetFlag?.section_index,
        widget_index: removeWidgetFlag?.widget_index,
        template_id: screen_id,
        widget_id: widget_id,
        widget_uuid: widget_metadata?.widget_uuid,
        section_id: section_id,
        screen: screen,
        exclude_words: [],
        include_words: keyword?.length > 0 ? [keyword] : [],
        comp_include_words: [],
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        isBrandModified: false,
        temporary_words: temporary_words,
        brand_id: !group ? [id] : null,
        brand_group: group ? [name] : null,
        wc_hide_temporary: workspace_privileges?.wc_hide_temporary,
        wc_hide_permanent: workspace_privileges?.wc_hide_permanent,
        wc_hide_brand: workspace_privileges?.wc_hide_brand,
      };
      dispatch(
        setCommandCenterWordcloudModifyWords(
          authParams,
          paneObject,
          null,
          "hidewordonbrandlevel"
        )
      );
    } else {
      let index = getPaneIndex(panes, activeKey);
      let section_metadata = panes[index]?.section
        ? panes[index]?.section[0]
        : panes[index]?.sections?.[removeWidgetFlag?.section_index];

      let widget_metadata = panes[index]?.section
        ? panes[index]?.section[0]?.widgets[removeWidgetFlag?.widget_index]
        : panes[index]?.sections?.[removeWidgetFlag?.section_index]?.widgets[
            removeWidgetFlag?.widget_index
          ];
      let widget_id = widget_metadata?.parentId
        ? widget_metadata?.parentId
        : widget_metadata?.childId
        ? widget_metadata?.childId
        : widget_metadata?.widget_id;
      let comp_include_words = [];
      if (widget_metadata?.duplicate_for_brands) {
        widget_id = widget_metadata?.parentId
          ? widget_metadata?.parentId
          : widget_metadata?.childId
          ? widget_metadata?.childId
          : widget_metadata?.widget_id;
        let brand_id = widget_metadata?.payload?.brand_list?.[0]?.brand_id;
        comp_include_words.push({
          [brand_id]: keyword?.length > 0 ? [keyword] : [],
        });
      }
      // let brandIdsOrGroups = panes[index].brands.columns.map(
      //   (brand) => brand.name
      // );
      // let brandGroups = panes[index].brands.columns[0].group;
      let paneObject = {
        competitorBrands: competitorBrands,
        widget_metadata: widget_metadata,
        section_index: removeWidgetFlag?.section_index,
        widget_index: removeWidgetFlag?.widget_index,
        template_id: panes[index]?.template_id,
        widget_id: widget_id,
        widget_uuid: widget_metadata?.widget_uuid,
        section_id: section_metadata?.section_id,
        panes: panes,
        index: index,
        activeKey: activeKey,
        exclude_words: [],
        include_words: keyword?.length > 0 ? [keyword] : [],
        comp_include_words: [],
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        isBrandModified: false,
        temporary_words: temporary_words,
        brand_id: !group ? [id] : null,
        brand_group: group ? [name] : null,
        wc_hide_temporary: workspace_privileges?.wc_hide_temporary,
        wc_hide_permanent: workspace_privileges?.wc_hide_permanent,
        wc_hide_brand: workspace_privileges?.wc_hide_brand,
      };
      dispatch(
        setWordcloudModifyWords(
          authParams,
          paneObject,
          false,
          "hidewordonbrandlevel"
        )
      );
    }
  };

  const unhidePermanently = (keyword) => {
    if (
      authParams?.screen_id === "000-000-552" ||
      authParams?.screen_id === "000-000-556"
    ) {
      dispatch(setDateAggregationLoader(true));
    }
    if (authParams?.screen_id) {
      // code for unhide Permanently
      let section_metadata =
        removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : removeWidgetFlag?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : screen?.section && screen?.section?.[0]
          ? screen?.section?.[0]
          : null;

      let section_id = section_metadata?.section_id
        ? section_metadata?.section_id
        : screen?.section_id;
      let widget_metadata =
        removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
          removeWidgetFlag?.widget_index
        ]
          ? screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
              removeWidgetFlag?.widget_index
            ]
          : removeWidgetFlag?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
          ? screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
          : screen?.widgets && screen?.widgets?.[removeWidgetFlag?.widget_index]
          ? screen?.widgets && screen?.widgets?.[removeWidgetFlag?.widget_index]
          : null;

      let screen_id = screen?.screen_id;
      let widget_id = widget_metadata?.parentId
        ? widget_metadata?.parentId
        : widget_metadata?.childId
        ? widget_metadata?.childId
        : widget_metadata?.widget_id;
      let comp_include_words = [];
      if (widget_metadata?.duplicate_for_brands) {
        widget_id = widget_metadata?.parentId
          ? widget_metadata?.parentId
          : widget_metadata?.childId
          ? widget_metadata?.childId
          : widget_metadata?.widget_id;
        let brand_id = widget_metadata?.payload?.brand_list?.[0]?.brand_id;
        comp_include_words.push({
          [brand_id]: keyword?.length > 0 ? [keyword] : [],
        });
      }
      let paneObject = {
        competitorBrands: competitorBrands,
        widget_metadata: widget_metadata,
        section_index: removeWidgetFlag?.section_index,
        widget_index: removeWidgetFlag?.widget_index,
        template_id: screen_id,
        widget_id: widget_id,
        widget_uuid: widget_metadata?.widget_uuid,
        section_id: section_id,
        screen: screen,
        exclude_words: [],
        include_words: keyword?.length > 0 ? [keyword] : [],
        comp_include_words: comp_include_words,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        isBrandModified: false,
        temporary_words: temporary_words,
        wc_hide_temporary: workspace_privileges?.wc_hide_temporary,
        wc_hide_permanent: workspace_privileges?.wc_hide_permanent,
        wc_hide_brand: workspace_privileges?.wc_hide_brand,
      };
      dispatch(
        setCommandCenterWordcloudModifyWords(
          authParams,
          paneObject,
          null,
          "hidewordpermanently"
        )
      );
    } else {
      let index = getPaneIndex(panes, activeKey);
      let section_metadata = panes[index]?.section
        ? panes[index]?.section[0]
        : panes[index]?.sections?.[removeWidgetFlag?.section_index];

      let widget_metadata = panes[index]?.section
        ? panes[index]?.section[0]?.widgets[removeWidgetFlag?.widget_index]
        : panes[index]?.sections?.[removeWidgetFlag?.section_index]?.widgets[
            removeWidgetFlag?.widget_index
          ];
      let widget_id = widget_metadata?.parentId
        ? widget_metadata?.parentId
        : widget_metadata?.childId
        ? widget_metadata?.childId
        : widget_metadata?.widget_id;
      let comp_include_words = [];
      if (widget_metadata?.duplicate_for_brands) {
        widget_id = widget_metadata?.parentId
          ? widget_metadata?.parentId
          : widget_metadata?.childId
          ? widget_metadata?.childId
          : widget_metadata?.widget_id;
        let brand_id = widget_metadata?.payload?.brand_list?.[0]?.brand_id;
        comp_include_words.push({
          [brand_id]: keyword?.length > 0 ? [keyword] : [],
        });
      }
      let paneObject = {
        competitorBrands: competitorBrands,
        widget_metadata: widget_metadata,
        section_index: removeWidgetFlag?.section_index,
        widget_index: removeWidgetFlag?.widget_index,
        template_id: panes[index]?.template_id,
        widget_id: widget_id,
        widget_uuid: widget_metadata?.widget_uuid,
        section_id: section_metadata?.section_id,
        panes: panes,
        index: index,
        activeKey: activeKey,
        exclude_words: [],
        include_words: keyword?.length > 0 ? [keyword] : [],
        comp_include_words: comp_include_words,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        isBrandModified: false,
        temporary_words: temporary_words,
        wc_hide_temporary: workspace_privileges?.wc_hide_temporary,
        wc_hide_permanent: workspace_privileges?.wc_hide_permanent,
        wc_hide_brand: workspace_privileges?.wc_hide_brand,
      };
      dispatch(
        setWordcloudModifyWords(
          authParams,
          paneObject,
          false,
          "hidewordpermanently"
        )
      );
    }
  };
  const unhideTemporaryly = (keyword) => {
    if (
      authParams?.screen_id === "000-000-552" ||
      authParams?.screen_id === "000-000-556"
    ) {
      dispatch(setDateAggregationLoader(true));
    }
    if (authParams?.screen_id) {
      // code for unhide temporaryly
      let update_temporary_words = { ...temporary_words };
      let section_metadata =
        removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : removeWidgetFlag?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : screen?.section && screen?.section?.[0]
          ? screen?.section?.[0]
          : null;

      let section_id = section_metadata?.section_id
        ? section_metadata?.section_id
        : screen?.section_id;
      let widget_metadata =
        removeWidgetFlag?.section_index !== null &&
        removeWidgetFlag?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
          removeWidgetFlag?.widget_index
        ]
          ? screen?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
              removeWidgetFlag?.widget_index
            ]
          : removeWidgetFlag?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[removeWidgetFlag?.section_index]
          ? screen?.sections?.[removeWidgetFlag?.section_index]
          : screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
          ? screen?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
          : screen?.widgets && screen?.widgets?.[removeWidgetFlag?.widget_index]
          ? screen?.widgets && screen?.widgets?.[removeWidgetFlag?.widget_index]
          : null;

      let widget_id = widget_metadata?.widget_id;
      let template_id = screen?.screen_id;
      //for exploded wordcloud by comptitor brands
      if (widget_metadata?.duplicate_for_brands) {
        widget_id = getTemporaryWordWidgetId(widget_metadata);
      }
      let words = update_temporary_words?.[template_id]?.[section_id]?.[
        widget_id
      ]?.exclude_words?.filter((el) => el !== keyword);
      if (update_temporary_words?.[template_id]?.[section_id]?.[widget_id])
        update_temporary_words[template_id][section_id][
          widget_id
        ].exclude_words = [...words];
      widget_metadata.temp_exclude_words = [...words];
      dispatch(setTemporaryWords(update_temporary_words));
      callChartApi(
        update_temporary_words?.[template_id]?.[section_id]?.[widget_id]
          ?.exclude_words,
        widget_metadata
      );
    } else {
      let update_temporary_words = { ...temporary_words };
      let index = getPaneIndex(panes, activeKey);
      let section_id = panes[index]?.section
        ? panes[index]?.section?.[0]?.section_id
        : panes[index]?.sections?.[removeWidgetFlag?.section_index]?.section_id;
      let widget_id = panes[index]?.section
        ? panes[index]?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
            ?.widget_id
        : panes[index]?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
            removeWidgetFlag?.widget_index
          ]?.widget_id;

      let template_id = panes[index]?.template_id;
      let widget_metadata = panes[index]?.section
        ? panes[index]?.section?.[0]?.widgets?.[removeWidgetFlag?.widget_index]
        : panes[index]?.sections?.[removeWidgetFlag?.section_index]?.widgets?.[
            removeWidgetFlag?.widget_index
          ];
      //for exploded wordcloud by comptitor brands
      if (widget_metadata?.duplicate_for_brands) {
        widget_id = getTemporaryWordWidgetId(widget_metadata);
      }
      let words = update_temporary_words?.[template_id]?.[section_id]?.[
        widget_id
      ]?.exclude_words?.filter((el) => el !== keyword);
      if (update_temporary_words?.[template_id]?.[section_id]?.[widget_id])
        update_temporary_words[template_id][section_id][
          widget_id
        ].exclude_words = [...words];
      widget_metadata.temp_exclude_words = [...words];
      dispatch(setTemporaryWords(update_temporary_words));
      callChartApi(
        update_temporary_words?.[template_id]?.[section_id]?.[widget_id]
          ?.exclude_words,
        widget_metadata
      );
    }
  };
  const callChartApi = (exclude_words, widget_metadata) => {
    if (authParams?.screen_id) {
      dispatch(
        updateScreenWidgetPropdataWithClearGraphData(
          removeWidgetFlag?.section_index,
          removeWidgetFlag?.widget_index,
          {
            prop_name: "temp_exclude_words",
            prop_value: getUniqueValues(exclude_words),
          }
        )
      );
    } else {
      let metadata = widget_metadata;
      let index = getPaneIndex(panes, activeKey);

      let duration = panes?.[index]?.duration;

      // let global_brands = getGlobalBrands(
      //   panes[index]?.brands,
      //   global_dashboard_single_brands,
      //   global_dashboard_brands,
      //   panes[index]?.template_type
      // );
      let global_brands = panes?.[index]?.brands;

      let widgetObj = {
        brand_groups: metadata?.brand_groups,
        singleBrands: brands,
      };

      let filter = getAllFilters(
        graphConditionConfig,
        panes,
        index,
        removeWidgetFlag?.section_index,
        removeWidgetFlag?.widget_index,
        brandlogicalgroup,
        metadata?.brand_ids, //logical brand change
        widgetObj
      );
      let obj = {};
      obj.section_index = removeWidgetFlag?.section_index;
      obj.widget_index = removeWidgetFlag?.widget_index;
      obj.data = metadata;
      obj.panes = panes;
      obj.paneIndex = index;
      obj.duration = duration;
      obj.global_brands = global_brands;
      obj.filter = filter;
      obj.temporary_words = temporary_words;
      obj.brandlogicalgroup = brandlogicalgroup;
      obj.brands = brands;
      obj.graphConditionConfig = graphConditionConfig;
      obj.authParams = authParams;
      obj.exclude_words = exclude_words;
      obj.type = "view";

      obj.filter_dropdown = metadata?.filter_dropdown
        ? metadata?.filter_dropdown
        : [];
      obj.filter_by_dropdown = metadata?.filter_by_dropdown
        ? metadata?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = metadata?.filter_by_dropdown_data
        ? metadata?.filter_by_dropdown_data
        : [];

      let widgetGraphObject = getWidgetGraphObject(obj);
      widgetGraphObject.isNetworkChartV2 =
        widgetGraphObject?.chart?.chart_type === "network-graph-v2"
          ? true
          : false;

      let indexes = {
        pane_index: index,
        section_index:
          removeWidgetFlag?.section_index >= 0
            ? removeWidgetFlag?.section_index
            : null,
        panes: panes,
        widget_index: removeWidgetFlag?.widget_index,
        widget_id: metadata?.widget_id,
        graph_type: metadata?.graph_type,
        section_id: shareTemplateData
          ? removeWidgetFlag?.section_index >= 0
            ? shareTemplateData?.sections?.[removeWidgetFlag?.section_index]
                ?.section_id
            : shareTemplateData?.section?.[0]?.section_id
          : footerValue?.template
          ? removeWidgetFlag?.section_index >= 0
            ? Section?.[removeWidgetFlag?.section_index]?.id
            : Section?.[0]?.id
          : removeWidgetFlag?.section_index >= 0
          ? panes?.[index]?.sections?.[removeWidgetFlag?.section_index]
              ?.section_id
          : panes?.[index]?.section?.[0]?.section_id,
        template_details: templateDetails,
      };

      if (authParams?.category_id && brands) {
        widgetGraphObject?.graph_type === "aggregate"
          ? dispatch(
              setAggregateData(
                widgetGraphObject,
                indexes //widget data
              )
            )
          : widgetGraphObject?.primary
          ? dispatch(
              setGraphData(
                widgetGraphObject,
                indexes //widget data
              )
            )
          : graphConditionConfig?.[`data-source`]?.includes(
              widgetGraphObject?.data_source
            )
          ? dispatch(setPageChart(authParams, widgetGraphObject, indexes))
          : (widgetGraphObject?.x_axis ||
              widgetGraphObject?.y_series ||
              widgetGraphObject?.chart) &&
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
      }

      let section_metadata = panes[index]?.sections
        ? panes[index]?.sections?.[removeWidgetFlag?.section_index]
        : panes[index]?.section && panes[index]?.section?.[0];

      let sectionObj = {
        panes: panes,
        index: index,
        section_index:
          removeWidgetFlag?.section_index >= 0
            ? removeWidgetFlag?.section_index
            : null,

        widget_index: removeWidgetFlag?.widget_index,

        singleBrands: brands,
      };
      dispatch(
        setWidgetData(
          metadata,
          index,
          panes,
          removeWidgetFlag?.section_index >= 0
            ? removeWidgetFlag?.section_index
            : null,
          section_metadata?.section_id, //section id for only widgets
          sectionObj,
          brands
        )
      );
    }
  };
  const onSearch = (e, type) => {
    if (type === "permanent") {
      setsearchPermanent(e.target.value);
    } else if (type === "permanentbrand") {
      setsearchPermanentBrand(e.target.value);
    } else setsearchtext(e.target.value);
  };
  return (
    <div
      className={`${
        authParams?.screen_id && isWidgetEdit
          ? "Screen__content--col3 open"
          : ""
      } col-12 ${isWidgetEdit ? "col-md-3" : "d-none"} pl-0 pr-0 ${
        authParams?.screen_id ? "" : "editWidgetAnalysis"
      }`}
    >
      {
        <>
          {pdfEditorPanelSatus ? (
            <>
              <div class="" style={{ zIndex: "0" }} />
              <div
                className="pdfEditorPanel bg__white"
                style={{ zIndex: "10" }}
              >
                <div
                  onClick={() => handleBackButton()}
                  className="portlet__title fontSize-16 font-weight500 cursor-pointer bg__white border-bottom border-color"
                  style={{ padding: "0.8rem 1rem" }}
                >
                  <span className="d-flex align-items-center">
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? BackArrowWhite
                          : BackArrow
                      }
                      alt="Back Arrow"
                      className="mr-1"
                      style={{ maxWidth: "2rem" }}
                    />
                    {"Add Note"}
                  </span>
                </div>
                <div className="pdfEditorPanel__content">
                  {pdfEditorPanelType === "addnote" && (
                    <div className="pdfEditorPanel__addNote">
                      <CkEditorPulgin note={widget_metadata?.note} />
                    </div>
                  )}
                </div>

                {pdfEditorPanelType === "addnote" && (
                  <div className="text-right d-flex align-items-center justify-content-between pl-15 pr-15 pt-15 border-color border-top">
                    <Button
                      className="btn_Clear"
                      onClick={() => handleBackButton()}
                    >
                      Cancel
                    </Button>
                    <div className="d-flex align-items-center">
                      <Button
                        onClick={() => handleDone("note_edited")}
                        className="ant-btn-primary_blue"
                        type="primary"
                        disabled={
                          pdfEditorObj?.editorValue &&
                          pdfEditorObj?.editorValue?.length > 0
                            ? false
                            : false
                        }
                      >
                        Save Note
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div ref={ref} className="bg__white">
              <div
                className="portlet__title fontSize-16 font-weight500 cursor-pointer bg__white border-bottom border-color"
                style={{ padding: "0.8rem 1rem" }}
              >
                <span className="d-flex align-items-center">
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? BackArrowWhite
                        : BackArrow
                    }
                    alt="Back Arrow"
                    className="mr-1"
                    style={{ maxWidth: "2rem" }}
                    onClick={handleBackButton}
                  />
                  {authParams?.screen_id === "000-000-557"
                    ? "Settings"
                    : removeWidgetFlag?.value
                    ? "Hidden Words"
                    : "Filters"}
                </span>
              </div>
              {/* <div 
        className="custom_scroll" 
        style={{ height: "calc(100vh - 10rem)", overflow: "auto" , marginRight:'0.5rem' }}
        > */}
              {removeWidgetFlag?.value ? (
                <Tabs
                  defaultActiveKey="1"
                  onChange={(key) => callback(key)}
                  className="pl-15 workSpace__tabs"
                >
                  <TabPane tab="Temporary Hidden" key="1">
                    <div className="mr-2">
                      <Input
                        size="large"
                        placeholder="Search hidden words"
                        onChange={onSearch}
                        value={searchtext}
                        suffix={
                          <img
                            src={
                              authParams?.theme_type === "1"
                                ? searchWhite_icon
                                : search
                            }
                            alt="filter Search"
                            style={{ maxWidth: "2rem" }}
                          />
                        }
                        className="mt-2 border-color "
                      />
                    </div>

                    <div
                      style={{
                        pointerEvents: graphLoader ? "none" : "auto",
                        opacity: graphLoader ? "0.5" : "1",
                        maxHeight: "calc(100vh - 14rem)",
                      }}
                      className="text_heading-Slab custom_scroll1 fontSize-12 mt-2 mr-1 ml-0 d-flex flex-column custom_scroll2 custom_scroll1"
                    >
                      {temporaryWordArray?.length > 0 ? (
                        <>
                          {temporaryWordArray?.map((el, i) => {
                            if (
                              el
                                ?.toLowerCase()
                                ?.includes(searchtext?.toLowerCase()) ||
                              !searchtext
                            ) {
                              Tempcount = Tempcount + 1;
                              return (
                                <p className=" d-flex justify-content-between mb-0 p-2 mr-1 ml-0  keyword">
                                  <span style={{ marginRight: "0.2rem" }}>
                                    {el}
                                  </span>
                                  <span
                                    className="unhide cursor-pointer"
                                    onClick={() => unhideTemporaryly(el)}
                                  >
                                    Unhide
                                  </span>
                                </p>
                              );
                            }
                          })}
                          {Tempcount === 0 && (
                            <div className="p-1 mt-1 text-regular">
                              No Keywords found
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="p-1 mt-1 text-regular">
                          No Keywords found
                        </div>
                      )}
                    </div>
                  </TabPane>
                  <TabPane tab="Permanently Hidden" key="2">
                    <div className="mr-2">
                      <Input
                        size="large"
                        placeholder="Search hidden words"
                        onChange={(e) => onSearch(e, "permanent")}
                        value={searchPermanent}
                        suffix={
                          <img
                            src={
                              authParams?.theme_type === "1"
                                ? searchWhite_icon
                                : search
                            }
                            alt="filter Search"
                            style={{ maxWidth: "2rem" }}
                          />
                        }
                        className="mt-2 border-color "
                      />
                    </div>
                    <div
                      style={{
                        pointerEvents: graphLoader ? "none" : "auto",
                        opacity: graphLoader ? "0.5" : "1",
                        maxHeight: "calc(100vh - 14rem)",
                        overflow: "auto",
                      }}
                      className="text_heading-Slab custom_scroll1 fontSize-12  mt-2 mr-1 ml-0 d-flex flex-column"
                    >
                      {permanentWordArray?.length > 0 ? (
                        <>
                          {permanentWordArray?.map((el, i) => {
                            if (
                              el
                                ?.toLowerCase()
                                ?.includes(searchPermanent?.toLowerCase()) ||
                              !searchPermanent
                            ) {
                              Permanentcount = Permanentcount + 1;
                              return (
                                <p className=" d-flex justify-content-between mb-0 p-2 mr-1 ml-0 keyword">
                                  <span style={{ marginRight: "0.2rem" }}>
                                    {el}
                                  </span>
                                  <span
                                    className="unhide cursor-pointer"
                                    onClick={() => unhidePermanently(el)}
                                  >
                                    Unhide
                                  </span>
                                </p>
                              );
                            }
                          })}
                          {Permanentcount === 0 && (
                            <div className="p-1 mt-1 text-regular">
                              No Keywords found
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="p-1 mt-1 text-regular">
                          No Keywords found
                        </div>
                      )}
                    </div>
                  </TabPane>
                  <TabPane tab="Permanently Brand Hidden" key="3">
                    <div className="mr-2">
                      <Input
                        size="large"
                        placeholder="Search brands/groups"
                        onChange={(e) => onSearch(e, "permanentbrand")}
                        value={searchPermanentBrand}
                        suffix={
                          <img
                            src={
                              authParams?.theme_type === "1"
                                ? searchWhite_icon
                                : search
                            }
                            alt="filter Search"
                            style={{ maxWidth: "2rem" }}
                          />
                        }
                        className="mt-2 border-color "
                      />
                    </div>
                    <div
                      style={{
                        pointerEvents: graphLoader ? "none" : "auto",
                        opacity: graphLoader ? "0.5" : "1",
                        maxHeight: "calc(100vh - 14rem)",
                        overflow: "auto",
                      }}
                      className="text_heading-Slab custom_scroll1 fontSize-12  mt-2 mr-1 ml-0 d-flex flex-column"
                    >
                      {Object.keys(groupedData)?.length > 0 ? (
                        Object.keys(groupedData).filter((group) =>
                          group
                            .toLowerCase()
                            .includes(searchPermanentBrand?.toLowerCase() || "")
                        ).length > 0 ? (
                          Object.keys(groupedData)
                            .filter((group) =>
                              group
                                .toLowerCase()
                                .includes(
                                  searchPermanentBrand?.toLowerCase() || ""
                                )
                            )
                            .map((group) => (
                              <Collapse
                                bordered={false}
                                expandIconPosition="right"
                                className="bg__white p-0 m-0"
                                defaultActiveKey={["1"]}
                                key={group}
                              >
                                <Panel
                                  header={
                                    <span className="ant-collapse-header-text text_heading-Slab font-size14">
                                      {group}
                                    </span>
                                  }
                                  key={group}
                                  className="text_heading-Slab custom_scroll1 fontSize-12 mt-2 mr-1 ml-0 d-flex flex-column"
                                  showArrow={true}
                                >
                                  <div className="mr-2">
                                    <Input
                                      size="large"
                                      placeholder="Search hidden words"
                                      onChange={(e) =>
                                        handleSearch(e.target.value, group)
                                      }
                                      value={searchTerms[group] || ""}
                                      suffix={
                                        <img
                                          src={
                                            authParams?.theme_type === "1"
                                              ? searchWhite_icon
                                              : search
                                          }
                                          alt="filter Search"
                                          style={{ maxWidth: "2rem" }}
                                        />
                                      }
                                      className="mt-2 border-color "
                                    />
                                  </div>

                                  {/* {groupedData[group].length > 0 && (
                            <Search
                              placeholder="Search items"
                              onChange={(e) =>
                                handleSearch(e.target.value, group)
                              }
                              value={searchTerms[group] || ""}
                              style={{ marginBottom: 8, padding: "0.4rem" }}
                            />
                          )} */}
                                  {groupedData[group].length > 0 &&
                                    groupedData[group].some((item) =>
                                      item.value
                                        .toLowerCase()
                                        .includes(
                                          searchTerms[group]?.toLowerCase() ||
                                            ""
                                        )
                                    ) && (
                                      <>
                                        <List
                                          style={{ padding: "0.8rem" }}
                                          dataSource={
                                            searchTerms[group]
                                              ? groupedData[group].filter(
                                                  (item) =>
                                                    item.value
                                                      .toLowerCase()
                                                      .includes(
                                                        searchTerms[
                                                          group
                                                        ].toLowerCase()
                                                      )
                                                )
                                              : groupedData[group]
                                          }
                                          renderItem={(item) => (
                                            <>
                                              <List.Item
                                                style={{ borderBottom: "none" }}
                                                className="text_heading-Slab font-size12 d-flex justify-content-between mb-0 p-2 mr-1 ml-0 keyword"
                                              >
                                                <span
                                                  style={{
                                                    marginRight: "0.2rem",
                                                  }}
                                                >
                                                  {item.value}
                                                </span>
                                                {
                                                  <span
                                                    className="unhide cursor-pointer"
                                                    onClick={() =>
                                                      unhidePermanentlyBrand(
                                                        item.value,
                                                        group,
                                                        item.brand_id
                                                      )
                                                    }
                                                  >
                                                    Unhide
                                                  </span>
                                                }
                                              </List.Item>
                                            </>
                                          )}
                                        />
                                      </>
                                    )}

                                  {searchTerms[group] &&
                                    !groupedData[group].some((item) =>
                                      item.value
                                        .toLowerCase()
                                        .includes(
                                          searchTerms[group].toLowerCase()
                                        )
                                    ) && (
                                      <div className="p-1 mt-1 text-regular text_heading-Slab font-size12 d-flex justify-content-between mb-0 p-2 mr-1 ml-0 keyword">
                                        No keywords found
                                      </div>
                                    )}
                                </Panel>
                              </Collapse>
                            ))
                        ) : (
                          <div className="p-1 mt-1 text-regular">
                            No keywords found
                          </div>
                        )
                      ) : (
                        <div className="p-1 mt-1 text-regular">
                          No keywords found
                        </div>
                      )}
                    </div>
                  </TabPane>
                </Tabs>
              ) : (
                <Tabs
                  defaultActiveKey="1"
                  onChange={(key) => callback(key)}
                  className={`pl-15 workSpace__tabs ${
                    authParams?.screen_id &&
                    (screensWithPersistedFilters.includes(
                      authParams?.screen_id
                    ) ||
                      authParams?.screen_id === "000-000-550")
                      ? " screen_tabs"
                      : ""
                  }`}
                  destroyInactiveTabPane={true}
                >
                  {selectedSection?.type === "command_center_widget" ? (
                    ""
                  ) : (
                    <TabPane tab="General" key="1">
                      <General
                        setColumnSpan={setColumnSpan}
                        selectedSection={selectedSection}
                        widget_metadata={widget_metadata}
                      />
                    </TabPane>
                  )}

                  {widget_metadata?.type === "predefined" &&
                  Array.isArray(widget_metadata?.supported_filters) &&
                  !widget_metadata?.supported_filters?.filter(
                    (el) => el !== "SocialMediaProfiles"
                  )?.length ? (
                    ""
                  ) : widget_metadata?.type === "predefined" &&
                    !Array.isArray(widget_metadata?.supported_filters) ? (
                    ""
                  ) : (
                    <TabPane tab="Filters" key="2" className="Filters_Popup">
                      <div
                        className="custom_scroll1"
                        style={{
                          overflow: "scroll",
                          maxHeight: `${
                            isPersonalisedBannerAdded && authParams?.screen_id
                              ? "78vh"
                              : "81vh"
                          }`,
                          overflowX: "hidden",
                        }}
                      >
                        {" "}
                        <Filters
                          setisFilterApplied={setisFilterApplied}
                          isFilterApplied={isFilterApplied}
                          widgetsClearFilter={widgetsClearFilter}
                          setwidgetsClearFilter={setwidgetsClearFilter}
                        />
                      </div>
                    </TabPane>
                  )}
                </Tabs>
              )}

              {/* </div> */}
              {/* DIV FOR BOTTOM BUTTONS IN FILTER DRAWER AND GENERAL SECTION */}
              <div
                className={`text-right  align-items-center justify-content-between p-15 border-color border-top ${
                  removeWidgetFlag?.value ? "d-none" : "d-flex"
                }`}
              >
                {(tabsKey ||
                  window.location.pathname === "/dashboard" ||
                  window.location.pathname === "/pin-dashboard" ||
                  getWindowLocationPath()?.toLowerCase() ===
                    "CommandCenter"?.toLowerCase()) && (
                  <Button className="btn_Clear" onClick={() => handleClear()}>
                    Clear Filter
                  </Button>
                )}
                <div className="d-flex align-items-center">
                  {!authParams?.screen_id && tabsKey ? (
                    <Checkbox checked={checked} onChange={(e) => handleLock(e)}>
                      Lock Filter
                    </Checkbox>
                  ) : (
                    ""
                  )}
                  {(tabsKey ||
                    window.location.pathname === "/dashboard" ||
                    window.location.pathname === "/pin-dashboard" ||
                    getWindowLocationPath()?.toLowerCase() ===
                      "CommandCenter"?.toLowerCase()) && (
                    <Tooltip
                      placement="topLeft"
                      title={
                        enteredPlannedValue?.[
                          selectedSection?.type === "widgetFilter"
                            ? "dashboard_widget"
                            : selectedSection?.type
                        ]?.data?.value?.length === 0
                          ? "Enter a planned value"
                          : widget_metadata?.profile_filters_flag &&
                            selectProfileFilterValue?.[widget_type]?.data
                              ?.columns?.length > 5
                          ? "More than 5 profiles can not be selected."
                          : widget_metadata?.profile_filters_flag &&
                            selectProfileFilterValue?.[widget_type]?.data
                              ?.columns?.length === 0
                          ? "Select atleast 1 profile to get data in widget."
                          : ""
                      }
                    >
                      <Button
                        disabled={
                          enteredPlannedValue?.[
                            selectedSection?.type === "widgetFilter"
                              ? "dashboard_widget"
                              : selectedSection?.type
                          ]?.data?.value?.length === 0
                            ? true
                            : widget_metadata?.profile_filters_flag &&
                              selectProfileFilterValue?.[widget_type]?.data
                                ?.columns?.length > 5
                            ? true
                            : widget_metadata?.profile_filters_flag &&
                              selectProfileFilterValue?.[widget_type]?.data
                                ?.columns?.length === 0
                            ? true
                            : false
                        }
                        style={{ color: "#fff" }}
                        onClick={() => handleDone()}
                        className="ant-btn-primary_blue"
                        type="primary"
                      >
                        Apply
                      </Button>
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      }
      {isFilterApplied && !tabsKey && (
        <Filters
          setisFilterApplied={setisFilterApplied}
          isFilterApplied={isFilterApplied}
          widgetsClearFilter={widgetsClearFilter}
          setwidgetsClearFilter={setwidgetsClearFilter}
          noteEdited={noteEdited}
          setNoteEdited={setNoteEdited}
        />
      )}
    </div>
  );
};

export default React.memo(EditWidget);
